// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","slateColor":"#555555","container":"QuestionFromChat_container__fT8jl","text":"QuestionFromChat_text__3w-Vj"};